// sessionStorage: date filters shared across Insights ↔ Activities within a tab.
// Resets when the tab closes — intentional, so stale dates don't surprise users.

export function saveSessionFilters(orgId, { from, to, tab, user_id, team_id, time_zone }) {
  if (!orgId) {
    return;
  }
  try {
    const key = `session_filters_${orgId}`;
    const next = Object.fromEntries(
      Object.entries({ from, to, tab, user_id, team_id, time_zone })
        .filter(([, v]) => v != null && v !== ''),
    );

    // Preserve a previously stored date range end when the caller only sets `from`
    // (e.g. Activities saves a single day). Drop it if `from` changed, so we don't
    // end up with an inverted range.
    if (next.from && next.to == null) {
      const previous = JSON.parse(sessionStorage.getItem(key)) || {};

      if (previous.to && previous.from === next.from) {
        next.to = previous.to;
      }
    }

    sessionStorage.setItem(key, JSON.stringify(next));
  } catch { /* private browsing */ }
}

function isValidDateString(value) {
  return typeof value === 'string' && !Number.isNaN(Date.parse(value));
}

function isValidSessionFilter(data) {
  if (!data || typeof data !== 'object') {
    return false;
  }
  if (!isValidDateString(data.from)) {
    return false;
  }
  if (data.to != null && !isValidDateString(data.to)) {
    return false;
  }

  return true;
}

export function getSessionFilters(orgId) {
  if (!orgId) {
    return null;
  }
  try {
    const data = JSON.parse(sessionStorage.getItem(`session_filters_${orgId}`));

    return isValidSessionFilter(data) ? data : null;
  } catch {
    return null;
  }
}
